import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  mixins: {
    toolbar: {
      minHeight: 25,
    },
  },
  typography: {
    subtitle1: {
      fontStyle: "italic",
      fontWeight: 500,
      fontFamily: 'Apple Color Emoji',
      fontSize: 20
    }
  }
});
